import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpXsrfTokenExtractor } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { settings } from '@environment';

@Injectable()
export class HttpXsrfInterceptor implements HttpInterceptor {
  constructor(private tokenExtractor: HttpXsrfTokenExtractor) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // skip assets
    if (req.urlWithParams.match('.*/assets/.*')) {
      return next.handle(req);
    }

    const token: string = this.tokenExtractor.getToken();

    if (
      token !== null &&
      (!req.headers.has(settings.xsrfTokenHeader) ||
        (req.headers.has(settings.xsrfTokenHeader) && req.headers.get(settings.xsrfTokenHeader) !== token))
    ) {
      req = req.clone({ headers: req.headers.set(settings.xsrfTokenHeader, token) });
    }

    return next.handle(req);
  }
}
